module.exports = __webpack_public_path__ + "static/media/TreatmentServicesInner.697aadc0.png";